import React from "react";
import AscComponent from "../../../components/AscComponent";
import { Row, Col, Button, ButtonGroup, Radio} from "react-bootstrap";
import "./Menu.css";
import InlineForm from "../../Elements/FromGroup/InlineForm";
import DatePicker from "react-datepicker";
import moment from "moment-timezone";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import * as GlobalConst from "../../../components/AscConstants";
import { MultiSelect } from "react-multi-select-component";
import CallTagSelect from "../../Elements/Select/CallTagSelect";
import TemplateSelect from "../../Elements/Select/TemplateSelect";
import BlockUi from "react-block-ui";
import SetDataWithSpeechBubble from "../../Elements/AscElements/SetDataWithSpeechBubble";
import * as faIcon from "@fortawesome/free-solid-svg-icons";

export default class Menu extends AscComponent {
    constructor(props) {
        super(props);
        
        this.state = {
        }
    }

    getSummaryBtn = () => {
        let {
            onSummary,
            langText,
            validationHandle, 
            compareFlag
        } = this.props;

        return (
            <Button
                className="ok-execute-btn button-size"
                bsStyle="info"
                onClick={e => onSummary()}
                disabled={!validationHandle("summary", compareFlag)}>
                {langText.Body.Summary}
            </Button>
        );
    }

    getClearBtn = () => {
        let {
            onClear,
            langText
        } = this.props;

        return (
            <Button
                className="default-button button-size clear-button"
                onClick={e => onClear()}>
                {langText.Body.Clear}
            </Button>
        );
    }

    getCompanySelectInfo = () => {
        let {
            state,
            langText,
            getFilterData,
            getScopeGreaterEqual,
            onSelectChange,
            validationHandle,
            compareFlag
        } = this.props;

        let itemArr = [];

        if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            itemArr.push(
                <InlineForm
                    key="company_id"
                    controlId="company_id"
                    className="padding-bottom-05"
                    label={langText.Body.CompanyName}
                    type="select"
                    onChange={e => onSelectChange(e, "cm12_id", compareFlag)}
                    options={compareFlag ? state.compare_company_select : state.company_select}
                    value={getFilterData("cm12_id", compareFlag) ? getFilterData("cm12_id", compareFlag).value : ""}
                    isClearable={true}
                    validationState={validationHandle("cm12_id", compareFlag)}
                    placeholder={langText.SelectOption.Placeholder_All_Select}
                />
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key="company_id"
                    controlId="company_id"
                    label={langText.Body.CompanyName}>
                    {this.props.userInfo ? this.props.userInfo.company_name : ""}
                </InlineForm.static>
            );
        }

        return itemArr;
    }

    getDepartmentSelectInfo = () => {
        let {
            state,
            langText,
            getFilterData,
            getScopeGreaterEqual,
            onMultiSelectChange,
            validationHandle,
            compareFlag
        } = this.props;

        let itemArr = [];

        if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
            itemArr.push(
                <InlineForm
                    key="department_id"
                    controlId="department_id"
                    className="padding-bottom-05"
                    label={langText.Body.DepartmentName}
                    type="select"
                    onChange={e => onMultiSelectChange(e, "department_id", compareFlag)}
                    options={compareFlag ? state.compare_department_select : state.departmentSelect}
                    value={getFilterData("department_id", compareFlag)}
                    isClearable={true}
                    isMulti={true}
                    validationState={validationHandle("department_id", compareFlag)}
                    placeholder={langText.SelectOption.Placeholder_All_Select}
                />
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key="department_id"
                    controlId="department_id"
                    label={langText.Body.DepartmentName}>
                    {this.props.userInfo ? this.props.userInfo.department_name : ""}
                </InlineForm.static>
            );
        }

        if ((compareFlag && this.props.state.compare_floor_flg === "Y") || (!compareFlag && this.props.state.floor_flg === "Y")) {
            if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department)) {
                itemArr.push(
                    <InlineForm
                        key="floor_id"
                        controlId="floor_id"
                        className="padding-bottom-05"
                        label={langText.Body.FloorName}
                        type="select"
                        onChange={e => onMultiSelectChange(e, "floor_id", compareFlag)}
                        options={compareFlag ? state.compare_floor_select : state.floorSelect}
                        value={getFilterData("floor_id", compareFlag)}
                        isClearable={true}
                        isMulti={true}
                        validationState={validationHandle("floor_id", compareFlag)}
                        placeholder={langText.SelectOption.Placeholder_All_Select}
                    />
                )
            } else {
                itemArr.push(
                    <InlineForm.static
                        key="floor_id"
                        controlId="floor_id"
                        label={langText.Body.FloorName}>
                        {this.props.userInfo ? this.props.userInfo.floor_name : ""}
                    </InlineForm.static>
                );
            }
        }
        return itemArr;
    }

    getTemplateSelectInfo = () => {
        let {
            state,
            langText,
            onSelectChange,
            compareFlag,
            modalShow,
            validationHandle
        } = this.props;
        let itemArr = [];

        itemArr.push(
            <InlineForm
                key="templateSelectForm"
                controlId="templateSelectForm"
                className="padding-bottom-05"
                label={
                    <div className="template-title-form">
                        <span>{langText.Body.Template}</span>
                        <Button
                            id="template-button"
                            bsStyle='primary'
                            bsSize='sm'
                            onClick={modalShow(null, "templateInsert", compareFlag)}
                            disabled={!validationHandle("template", compareFlag)}
                        >
                            {langText.Body.CallAnalysisTemplateInsert}
                        </Button>
                    </div>
                }
            >
                <TemplateSelect
                    className="padding-bottom-05"
                    state={state}
                    onChange={onSelectChange}
                    langText={langText}
                    modalShow={modalShow}
                    compareFlag={compareFlag}
                />
            </InlineForm>
        )

        return itemArr;
    }

    getConditionInfo = () => {
        let {
            state,
            onChange,
            getFilterData,
            langText,
            validationHandle,
            onKeyDownIntCheck,
            onSelectChange,
            onMultiSelectChange,
            onTimeChange,
            compareFlag
        } = this.props;
        let itemArr = [];

        // 通話履歴ID
        if (getFilterData("view_level") === "CallAnalysisSummaryCompare") {
            itemArr.push(
                <InlineForm
                    key="CallHistoryIdForm"
                    controlId="CallHistoryIdForm"
                    label={
                        <SetDataWithSpeechBubble
                            displayData={langText.Body.CallHistoryId}
                            speechBubbleData={langText.Message.IdOnlySearch}
                            infoIconDisplayFlag={true}
                            infoIconType={faIcon.faInfoCircle}
                            infoIconClassName="margin-left-02"
                            infoIconColor="silver"
                            infoIconSize="lg"
                        />
                    }
                >
                    <Col className="call-history-id summary-period">
                        <InlineForm
                            key="CallHistoryId"
                            controlId="CallHistoryId"
                            type="text"
                            value={getFilterData("ct60_id", compareFlag)}
                            onChange={e => onTimeChange(e, "ct60_id", compareFlag)}
                            colWidth={12}
                        />
                    </Col>
                </InlineForm>
            );
        }

        const start = getFilterData("start_datetime", compareFlag) ? getFilterData("start_datetime", compareFlag) : null;
        const end = getFilterData("end_datetime", compareFlag) ? getFilterData("end_datetime", compareFlag) : null;

        // 集計期間
        itemArr.push(
            <InlineForm
                key="CountingPeriod"
                controlId="CountingPeriod"
                label={langText.Body.CountingPeriod}
            >
                <Col className="padding-bottom-05 summary-period">
                    <InlineForm 
                        key="SummaryPeriod"
                        controlId="SummaryPeriod"
                        type="select"
                        value={compareFlag ? state.compare_summary_period_selected : state.summary_period_selected}
                        onChange={e => onSelectChange(e, compareFlag ? "compare_summary_period_selected" : "summary_period_selected", compareFlag)}
                        options={compareFlag ? state.compare_summary_period_select : state.summary_period_select}
                        placeholder = {langText.SelectOption.Placeholder}
                        validationState={validationHandle("summary_period_selected", compareFlag)}
                        colWidth={12}
                    />                
                </Col>
                <Col className="padding-bottom-05 margin-top-27">
                    <Col sm={12} md={5} lg={5} className="padding-left-0 padding-right-0">
                        <DatePicker
                            onChange={e => onChange(e, "start_datetime", true, compareFlag)}
                            selected={start ? (moment.isMoment(start) ? start : moment.tz(start, "Asia/Tokyo")) : null}
                            dateFormat="YYYY-MM-DD"
                            className="form-control"
                            todayButton={false}
                            onKeyDown={e => {e.preventDefault()}}
                            placeholderText={langText.Body.StartDate}
                            maxDate={end ? (moment.isMoment(end) ? end : moment.tz(end, "Asia/Tokyo")) : null}
                        />
                    </Col>
                    <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0 from-to">
                        <span>{langText.Body.FromTo}</span>
                    </Col>
                    <Col sm={12} md={5} lg={5} className="padding-left-0 padding-right-0">
                        <DatePicker
                            onChange={e => onChange(e, "end_datetime", true, compareFlag)}
                            selected={end ? (moment.isMoment(end) ? end : moment.tz(end, "Asia/Tokyo")) : null}
                            dateFormat="YYYY-MM-DD"
                            className="form-control"
                            todayButton={langText.Body.Today}
                            onKeyDown={e => {e.preventDefault()}}
                            placeholderText={langText.Body.EndDate}
                            minDate={start ? (moment.isMoment(start) ? start : moment.tz(start, "Asia/Tokyo")) : null}
                        />
                    </Col>
                </Col>
                <Col className="padding-bottom-35 margin-top-25 summary-period">
                    <InlineForm 
                        key="SummaryPeriodWeekday"
                        controlId="SummaryPeriodWeekday"
                        type="select"
                        value={getFilterData("weekday_selected", compareFlag)}
                        onChange={e => onMultiSelectChange(e, "weekday_selected", compareFlag)}
                        options={state.weekday_select}
                        isMulti={true}
                        placeholder={langText.SelectOption.Placeholder_Weekday_All_Select}
                        validationState={validationHandle("weekday_selected", compareFlag)}
                    />                
                </Col>
            </InlineForm>
        );

        // 通話時間帯
        itemArr.push(
            <InlineForm
                key="CallTimeZone"
                controlId="CallTimeZone"
                label={langText.Body.CallTimeZone}
                validationState={validationHandle("start_ji", compareFlag)}
            >
                <Col sm={12} md={12} className="padding-bottom-05 call-time">
                    <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0">
                        <InlineForm
                            key="start_ji"
                            controlId="start_ji"
                            type="number"
                            onKeyDown={e => onKeyDownIntCheck(e)}
                            onChange={e => onTimeChange(e, "start_ji", compareFlag)}
                            value={getFilterData("start_ji", compareFlag)}
                            validationState={validationHandle("start_ji", compareFlag)}
                            placeholder={langText.Body.Hour}
                        />
                    </Col>
                    <Col sm={12} md={1} lg={1} className="padding-left-0 padding-right-0 colon">
                        <span>{langText.Body.Colon}</span>
                    </Col>  
                    <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0">
                        <InlineForm
                            key="start_hun"
                            controlId="start_hun"
                            type="number"
                            onKeyDown={e => onKeyDownIntCheck(e)}
                            onChange={e => onTimeChange(e, "start_hun", compareFlag)}
                            value={getFilterData("start_hun", compareFlag)}
                            validationState={validationHandle("start_hun", compareFlag)}
                            placeholder={langText.Body.Minute}
                        />  
                    </Col>  
                    <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0 from-to">
                        <span>{langText.Body.FromTo}</span>
                    </Col>  
                    <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0">
                        <InlineForm
                            key="end_ji"
                            controlId="end_ji"
                            type="number"
                            onKeyDown={e => onKeyDownIntCheck(e)}
                            onChange={e => onTimeChange(e, "end_ji", compareFlag)}
                            value={getFilterData("end_ji", compareFlag)}
                            validationState={validationHandle("end_ji", compareFlag)}
                            placeholder={langText.Body.Hour}
                        />
                    </Col>  
                    <Col sm={12} md={1} lg={1} className="padding-left-0 padding-right-0 colon">
                        <span>{langText.Body.Colon}</span>
                    </Col>  
                    <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0">
                        <InlineForm
                            key="end_hun"
                            controlId="end_hun"
                            type="number"
                            onKeyDown={e => onKeyDownIntCheck(e)}
                            onChange={e => onTimeChange(e, "end_hun", compareFlag)}
                            value={getFilterData("end_hun", compareFlag)}
                            validationState={validationHandle("end_hun", compareFlag)}
                            placeholder={langText.Body.Minute}
                        />
                    </Col>    
                </Col>
            </InlineForm>
        );

        const operatorGroupFlag = state.summary_group === 'group' && state.view_level === 'CallAnalysisSummaryByOperator';
        // オペレーター名
        itemArr.push(
            <InlineForm
                key="OperatorNameForm"
                controlId="OperatorNameForm"
                label={operatorGroupFlag ? langText.Body.OperatorGroupName : langText.Body.OperatorName}
            >
                <Col className="padding-bottom-35 summary-period">
                    {
                        operatorGroupFlag ? (
                            <InlineForm 
                                key="OperatorGroup"
                                controlId="OperatorGroup"
                                type="select"
                                value={getFilterData("operator_groups") ? getFilterData("operator_groups").map(row => row.value) : []}
                                onChange={e => onMultiSelectChange(e, "operator_groups")}
                                options={state.operator_group_select}
                                isMulti={true}
                                placeholder={langText.SelectOption.Placeholder_All_Select}
                                validationState={validationHandle("operator_groups")}
                                colWidth={12}
                            />
                        ) : (
                            <InlineForm 
                                key="OperatorName"
                                controlId="OperatorName"
                                type="select"
                                value={getFilterData("operator_selected_id", compareFlag)}
                                onChange={e => onMultiSelectChange(e, "operator_selected_id", compareFlag)}
                                options={compareFlag ? state.compare_operator_info_select : state.operator_info_select}
                                isMulti={true}
                                placeholder={langText.SelectOption.Placeholder_All_Select}
                                validationState={validationHandle("operator_selected_id", compareFlag)}
                                colWidth={12}
                            />
                        )
                    }
                </Col>    
            </InlineForm>
        );

        // 内線番号
        itemArr.push(
            <InlineForm
                key="ExtensionNumberForm"
                controlId="ExtensionNumberForm"
                label={langText.Body.ExtensionNumber}
            >
                <Col className="padding-bottom-35 summary-period">
                    <InlineForm 
                        key="ExtensionNumber"
                        controlId="ExtensionNumber"
                        type="select"
                        value={getFilterData("extension_number_selected", compareFlag)}
                        onChange={e => onMultiSelectChange(e, "extension_number_selected", compareFlag)}
                        options={compareFlag ? state.compare_extension_number_select : state.extension_number_select}
                        isMulti={true}
                        placeholder={langText.SelectOption.Placeholder_All_Select}
                        validationState={validationHandle("extension_number_selected", compareFlag)}
                        colWidth={12}
                    />
                </Col>    
            </InlineForm>
        );

        // 外線番号
        itemArr.push(
            <InlineForm
                key="ExternalNumberForm"
                controlId="ExternalNumberForm"
                label={langText.Body.ExternalNumber}
            >
                <Col className="padding-bottom-35 summary-period">
                    <InlineForm 
                        key="ExternalNumber"
                        controlId="ExternalNumber"
                        type="select"
                        value={getFilterData("external_number", compareFlag)}
                        onChange={e => onMultiSelectChange(e, "external_number", compareFlag)}
                        options={compareFlag ? state.compare_external_number_select : state.external_number_select}
                        isMulti={true}
                        placeholder={langText.SelectOption.Placeholder_All_Select}
                        validationState={validationHandle("external_number", compareFlag)}
                        colWidth={12}
                    />    
                </Col>  
            </InlineForm>
        );

        // 発着区分
        itemArr.push(
            <InlineForm
                key="InOutTypeForm"
                controlId="InOutTypeForm"
                label={langText.Body.InOutType}
            >
                <Col className="padding-bottom-08 summary-period">
                    <ButtonGroup className="">
                        <Button
                            value="all"
                            onClick={e => onChange(e , "inout_type", false, compareFlag)}
                            className={compareFlag 
                                ? state.compare_filtered.map(
                                    row => row.id === "inout_type" && row.value === "all" ? "analysis-btn-focus":"")
                                : state.filtered.map(
                                    row => row.id === "inout_type" && row.value === "all" ? "analysis-btn-focus":"")}
                        >
                            {langText.Body.All}
                        </Button>
                        <Button
                            value="in"
                            onClick={e => onChange(e , "inout_type", false, compareFlag)}
                            className={compareFlag
                                ? state.compare_filtered.map(
                                    row => row.id === "inout_type" && row.value === "in" ? "analysis-btn-focus":"")
                                : state.filtered.map(
                                    row => row.id === "inout_type" && row.value === "in" ? "analysis-btn-focus":"")}
                        >
                            {langText.Body.Inbound}
                        </Button>
                        <Button
                            value="out"
                            onClick={e => onChange(e , "inout_type", false, compareFlag)}
                            className={compareFlag
                                ? state.compare_filtered.map(
                                    row => row.id === "inout_type" && row.value === "out" ? "analysis-btn-focus":"")
                                : state.filtered.map(
                                    row => row.id === "inout_type" && row.value === "out" ? "analysis-btn-focus":"")}
                        >
                            {langText.Body.Call}
                        </Button>
                    </ButtonGroup>
                </Col>
            </InlineForm>
        );

        // 通話結果
        itemArr.push(
            <InlineForm
                key="CallHistoryForm"
                controlId="CallHistoryForm"
                label={langText.Body.CallHistory}
            >
                <Col className="padding-bottom-35 summary-period">
                    <InlineForm 
                        key="CallHistory"
                        controlId="CallHistory"
                        type="select"
                        value={getFilterData("call_result", compareFlag)}
                        onChange={e => onMultiSelectChange(e, "call_result", compareFlag)}
                        options={state.call_result_select}
                        isMulti={true}
                        placeholder={langText.SelectOption.Placeholder_All_Select}
                        validationState={validationHandle("call_result", compareFlag)}
                        colWidth={12}
                    />   
                </Col> 
            </InlineForm>
        );

        // コール結果絞り込み条件
        const customOptionRenderer = ({ checked, option, onClick }) => {
            let margin = "";
            if (option.value.level === 1) margin = "10px";
            else if (option.value.level === 2) margin = "20px";

            return (
                <div
                    style={{
                        marginLeft: margin,
                        display: 'flex',
                        alignItems: 'center', 
                    }}
                >
                    <input type="checkbox" onClick={onClick} checked={checked} readOnly style={{ marginRight: '10px', cursor: "pointer" }} />
                    {option.label}
                </div>
            );
        };

        itemArr.push(
            <InlineForm
                key="CallResultFilterForm"
                controlId="CallResultFilterForm"
                label={langText.Body.CallResultFilter}
            >
                <Col className="padding-bottom-08 summary-period">
                    <MultiSelect
                        key="CallResultFilter"
                        value={compareFlag ? state.compare_call_result_filter : state.call_result_filter}
                        onChange={
                            e => onChange(e, "call_result_filter", false, compareFlag)
                        }
                        options={compareFlag ? state.compare_call_result_filter_select : state.call_result_filter_select}
                        overrideStrings={{
                            selectSomeItems: langText.SelectOption.Placeholder,
                            allItemsAreSelected: langText.SelectOption.Placeholder_allResult,
                            selectAll: langText.SelectOption.Placeholder_allResult,
                            selectAllFiltered: langText.SelectOption.Placeholder_searchAllResult,
                            search: langText.Body.Search,
                        }}
                        ItemRenderer={customOptionRenderer}
                        disableSearch
                    />
                </Col>
            </InlineForm>
        );

        // コール結果除外条件
        itemArr.push(
            <InlineForm
                key="CallResultExclusionForm"
                controlId="CallResultExclusionForm"
                label={langText.Body.CallResultExclusion}
            >
                <Col className="padding-bottom-08 summary-period">
                    <MultiSelect
                        key="CallResultExclusion"
                        value={compareFlag ? state.compare_call_result_exclusion : state.call_result_exclusion}
                        onChange={
                            e => onChange(e, "call_result_exclusion", false, compareFlag)
                        }
                        options={compareFlag ? state.compare_call_result_exclusion_select : state.call_result_exclusion_select}
                        overrideStrings={{
                            selectSomeItems: langText.SelectOption.Placeholder,
                            allItemsAreSelected: langText.SelectOption.Placeholder_allResult,
                            selectAll: langText.SelectOption.Placeholder_allResult,
                            selectAllFiltered: langText.SelectOption.Placeholder_searchAllResult,
                            search: langText.Body.Search,
                        }}
                        ItemRenderer={customOptionRenderer}
                        disableSearch
                    />
                </Col> 
            </InlineForm>
        );

        // 通話分類タグ
        itemArr.push(
            <InlineForm
                key="CallCategoryTagForm"
                controlId="CallCategoryTagForm"
                label={langText.Body.CallCategoryTag}
            >
                <Col className="padding-bottom-35 summary-period">
                    <InlineForm 
                        key="CallCategory"
                        controlId="CallCategory"
                        validationState={validationHandle("tags", compareFlag)}
                        colWidth={12}
                    >
                        <CallTagSelect
                            options={compareFlag ? state.compare_tag_select : state.tag_select}
                            onChange={onMultiSelectChange}
                            value={getFilterData("tags", compareFlag)}
                            langText={langText}
                            param={"tags"}
                            compareFlag={compareFlag}
                        />
                    </InlineForm>
                </Col>
            </InlineForm>
        );

        // 応対メモ
        {/*
            第２フェーズ対応
            itemArr.push(
                <>
                    <InlineForm
                        key="SupportMemoForm"
                        controlId="SupportMemoForm"
                        label={langText.Body.SupportMemo}
                    >
                        <InlineForm 
                            key="SupportMemo"
                            controlId="SupportMemo"
                            type="select"
                            value={getFilterData("support_memo")}
                            onChange={e => onMultiSelectChange(e, "support_memo")}
                            options={state.support_memo_select}
                            isMulti={true}
                            placeholder={langText.SelectOption.Placeholder_All_Select}
                            validationState={validationHandle("support_memo")}
                        />    
                    </InlineForm>
                    <InlineForm
                        key="SupportCheck"
                        controlId="SupportCheck"
                    >
                        <Checkbox
                            key="AllSupport"
                            checked={getFilterData("all_support")}
                            onChange={e => onChange(e, "all_support")}
                            className="padding-left-15"
                        >
                            {langText.Body.AllInclude}
                        </Checkbox>
                    </InlineForm>
                </>
            );
        */}
        return itemArr;
    }
    
    // 詳細条件
    getDetailConditionInfo = () => {
        let {
            state,
            onChange,
            getFilterData,
            langText,
            onClickAccordion,
            validationHandle,
            onKeyDownIntCheck,
            onTimeChange,
            compareFlag
        } = this.props;
        let itemArr = [];
        let accordion_flag = compareFlag ? state.compare_accordion_flag : state.accordion_flag;
        let pre_expanded = accordion_flag ? ["detailSettings"] : [];

        itemArr.push(
            <Accordion allowZeroExpanded preExpanded={pre_expanded}>
                <AccordionItem key="detailSettings" uuid="detailSettings">
                    <AccordionItemHeading>
                        <AccordionItemButton className="">
                            <div onClick={(e) => onClickAccordion(e, compareFlag)} className="padding-left-10 fa-11">
                                {compareFlag ? 
                                    <span className="accordion-menu font-blue">
                                        {state.compare_accordion_flag ? langText.Body.LessThan : langText.Body.Quotation}
                                    </span>
                                    : <span className="accordion-menu font-blue">
                                        {state.accordion_flag ? langText.Body.LessThan : langText.Body.Quotation}
                                    </span>}
                                <b className="font-blue">{langText.Body.DetailCondition}</b>
                            </div>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {/* 通話時間 */}
                        <InlineForm
                            key="TalkingTime"
                            controlId="TalkingTime"
                            label={langText.Body.TalkingTime}
                            validationState={validationHandle("call_start_hun", compareFlag)}
                        >
                            <Col sm={12} md={12} className="call-time">
                                <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0">
                                    <InlineForm
                                        key="call_start_hun"
                                        controlId="call_start_hun"
                                        type="number"
                                        onKeyDown={e => onKeyDownIntCheck(e)}
                                        onChange={e => onTimeChange(e, "call_start_hun", compareFlag)}
                                        value={getFilterData("call_start_hun", compareFlag)}
                                        validationState={validationHandle("call_start_hun", compareFlag)}
                                        placeholder={langText.Body.Minute}
                                    />
                                </Col>
                                <Col sm={12} md={1} lg={1} className="padding-left-0 padding-right-0 colon">
                                    <span>{langText.Body.Colon}</span>
                                </Col>  
                                <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0">
                                    <InlineForm
                                        key="call_start_byo"
                                        controlId="call_start_byo"
                                        type="number"
                                        onKeyDown={e => onKeyDownIntCheck(e)}
                                        onChange={e => onTimeChange(e, "call_start_byo", compareFlag)}
                                        value={getFilterData("call_start_byo", compareFlag)}
                                        validationState={validationHandle("call_start_byo", compareFlag)}
                                        placeholder={langText.Body.Second}
                                    />  
                                </Col>  
                                <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0 from-to">
                                    <span>{langText.Body.FromTo}</span>
                                </Col>  
                                <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0">
                                    <InlineForm
                                        key="call_end_hun"
                                        controlId="call_end_hun"
                                        type="number"
                                        onKeyDown={e => onKeyDownIntCheck(e)}
                                        onChange={e => onTimeChange(e, "call_end_hun", compareFlag)}
                                        value={getFilterData("call_end_hun", compareFlag)}
                                        validationState={validationHandle("call_end_hun", compareFlag)}
                                        placeholder={langText.Body.Minute}
                                    />
                                </Col>  
                                <Col sm={12} md={1} lg={1} className="padding-left-0 padding-right-0 colon">
                                    <span>{langText.Body.Colon}</span>
                                </Col>  
                                <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0">
                                    <InlineForm
                                        key="call_end_byo"
                                        controlId="call_end_byo"
                                        type="number"
                                        onKeyDown={e => onKeyDownIntCheck(e)}
                                        onChange={e => onTimeChange(e, "call_end_byo", compareFlag)}
                                        value={getFilterData("call_end_byo", compareFlag)}
                                        validationState={validationHandle("call_end_byo", compareFlag)}
                                        placeholder={langText.Body.Second}
                                    />
                                </Col>    
                            </Col>
                        </InlineForm>
                        {/* 総合評価 */}
                        <InlineForm
                            key="Score"
                            controlId="Score"
                            label={langText.Body.Score}
                            validationState={validationHandle("min_score", compareFlag)}
                        >
                            <Col className="call-time">
                                <Col sm={12} md={5} lg={5} className="width-40 padding-left-0 padding-right-0">
                                    <InlineForm
                                        key="MinScore"
                                        controlId="MinScore"
                                        type="number"
                                        onKeyDown={e => onKeyDownIntCheck(e)}
                                        onChange={e => onTimeChange(e, "min_score", compareFlag)}
                                        value={getFilterData("min_score", compareFlag)}
                                        validationState={validationHandle("min_score", compareFlag)}
                                        placeholder={langText.Body.NoMinLimit}
                                    />  
                                </Col>  
                                <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0 from-to">
                                    <span>{langText.Body.FromTo}</span>
                                </Col>  
                                <Col sm={12} md={5} lg={5} className="width-40 padding-left-0 padding-right-0">
                                    <InlineForm
                                        key="MaxScore"
                                        controlId="MaxScore"
                                        type="number"
                                        onKeyDown={e => onKeyDownIntCheck(e)}
                                        onChange={e => onTimeChange(e, "max_score", compareFlag)}
                                        value={getFilterData("max_score", compareFlag)}
                                        validationState={validationHandle("max_score", compareFlag)}
                                        placeholder={langText.Body.NoMaxLimit}
                                    />
                                </Col>
                            </Col>
                        </InlineForm>
                        {/* OP会話比率 */}
                        <div>
                            <InlineForm
                                key="TalkRate"
                                controlId="TalkRate"
                                label={langText.Body.TalkRate}
                                validationState={validationHandle("min_talk_rate", compareFlag)}
                            >
                                <Col sm={12} md={12} className="call-time">
                                    <Col sm={12} md={5} lg={5} className="width-40 padding-left-0 padding-right-0">
                                        <InlineForm
                                            key="MinTalkRate"
                                            controlId="MinTalkRate"
                                            type="number"
                                            onKeyDown={e => onKeyDownIntCheck(e)}
                                            onChange={e => onTimeChange(e, "min_talk_rate", compareFlag)}
                                            value={getFilterData("min_talk_rate", compareFlag)}
                                            validationState={validationHandle("min_talk_rate", compareFlag)}
                                            placeholder={langText.Body.NoMinLimit}
                                        />  
                                    </Col>  
                                    <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0 from-to">
                                        <span>{langText.Body.FromTo}</span>
                                    </Col>  
                                    <Col sm={12} md={5} lg={5} className="width-40 padding-left-0 padding-right-0">
                                        <InlineForm
                                            key="MaxTalkRate"
                                            controlId="MaxTalkRate"
                                            type="number"
                                            onKeyDown={e => onKeyDownIntCheck(e)}
                                            onChange={e => onTimeChange(e, "max_talk_rate", compareFlag)}
                                            value={getFilterData("max_talk_rate", compareFlag)}
                                            validationState={validationHandle("max_talk_rate", compareFlag)}
                                            placeholder={langText.Body.NoMaxLimit}
                                        />
                                    </Col>
                                </Col>
                            </InlineForm>
                        </div>
                        {/* 会話速度差 */}
                        <InlineForm
                            key="TalkSpeedDifference"
                            controlId="TalkSpeedDifference"
                            label={langText.Body.TalkSpeedDifference}
                            validationState={validationHandle("min_speech_speed", compareFlag)}
                        >
                            <Col sm={12} md={12} className="call-time padding-bottom-05">
                                <Col sm={12} md={5} lg={5} className="width-40 padding-left-0 padding-right-0">
                                    <InlineForm
                                        key="MinTalkSpeed"
                                        controlId="MinTalkSpeed"
                                        type="number"
                                        onKeyDown={e => onKeyDownIntCheck(e)}
                                        onChange={e => onTimeChange(e, "min_speech_speed", compareFlag)}
                                        value={getFilterData("min_speech_speed", compareFlag)}
                                        validationState={validationHandle("min_speech_speed", compareFlag)}
                                        placeholder={langText.Body.NoMinLimit}
                                    />  
                                </Col>  
                                <Col sm={12} md={2} lg={2} className="padding-left-0 padding-right-0 from-to">
                                    <span>{langText.Body.FromTo}</span>
                                </Col>  
                                <Col sm={12} md={5} lg={5} className="width-40 padding-left-0 padding-right-0">
                                    <InlineForm
                                        key="MaxTalkSpeed"
                                        controlId="MaxTalkSpeed"
                                        type="number"
                                        onKeyDown={e => onKeyDownIntCheck(e)}
                                        onChange={e => onTimeChange(e, "max_speech_speed", compareFlag)}
                                        value={getFilterData("max_speech_speed", compareFlag)}
                                        validationState={validationHandle("max_speech_speed", compareFlag)}
                                        placeholder={langText.Body.NoMaxLimit}
                                    />
                                </Col>
                            </Col>
                        </InlineForm>
                        {/* コメント */}
                        {/* 
                            第2フェーズ対応
                            <InlineForm
                                key="CommentForm"
                                controlId="CommentForm"
                                label={langText.Body.Comment}
                            >
                                <div className="comment">
                                    <InlineForm
                                        key="Comment"
                                        controlId="Comment"
                                        type="text"
                                        value={getFilterData("comment")}
                                        onChange={e => onChange(e, "comment")}
                                        placeholder={langText.SelectOption.Placeholder_Comment_Search}
                                    />
                                </div>
                            </InlineForm>
                        */}
                        {/* キーワード */}
                        {/* 
                            第2フェーズ対応
                        <InlineForm
                            key="KeywordFrom"
                            controlId="KeywordForm"
                            label={langText.Body.Keyword}
                        >
                            <div className="keyword">
                                <Creatable
                                    isMulti
                                    isClearable
                                    value={getFilterData("keyword")}
                                    placeholder={langText.SelectOption.Placeholder_Keyword_Search}
                                    onChange = {e => onChange(e, "keyword")}
                                    noOptionsMessage={() => langText.SelectOption.Placeholder_Keyword_Search}
                                    formatCreateLabel={(inputText) => `${inputText} ${langText.Message.Creating}`}
                                />
                            </div>
                        </InlineForm>
                        <InlineForm
                            key="KeywordCheck"
                            controlId="KeywordCheck"
                        >
                            <Checkbox
                                key="AllKeyword"
                                checked={getFilterData("all_keyword")}
                                onChange={e => onChange(e, "all_keyword")}
                                className="padding-left-15"
                            >
                                {langText.Body.AllInclude}
                            </Checkbox>
                        </InlineForm>
                        */}
                        {/* 集計方法 */}
                        <InlineForm
                            key="SummaryMethod"
                            controlId="SummaryMethod"
                            label={langText.Body.SummaryMethod}
                        >
                            <Col xs={12} md={12} className="padding-left-0 font-size-085 margin-top--05">
                                <Col xs={12} md={4} lg={4}>
                                    {compareFlag ? 
                                        <Radio
                                            name="AverageValueCompare"
                                            key="AverageValueCompare"
                                            onChange={e => onChange(e, "summary_method", false, compareFlag)}
                                            checked={getFilterData("summary_method", compareFlag) === "average" ? true : false}
                                            value="average">
                                            {langText.Body.AverageValue}
                                        </Radio> : 
                                        <Radio
                                            name="AverageValue"
                                            key="AverageValue"
                                            onChange={e => onChange(e, "summary_method", false)}
                                            checked={getFilterData("summary_method") === "average" ? true : false}
                                            value="average">
                                            {langText.Body.AverageValue}
                                        </Radio>}
                                </Col>
                                <Col xs={12} md={4} lg={4}>
                                    {compareFlag ? 
                                        <Radio
                                            name="MedianValueCompare"
                                            key="MedianValueCompare"
                                            onChange={e => onChange(e, "summary_method", false, compareFlag)}
                                            checked={getFilterData("summary_method", compareFlag) === "median" ? true : false}
                                            value="median">
                                            {langText.Body.MedianValue}
                                        </Radio> : 
                                        <Radio
                                            name="MedianValue"
                                            key="MedianValue"
                                            onChange={e => onChange(e, "summary_method", false)}
                                            checked={getFilterData("summary_method") === "median" ? true : false}
                                            value="median">
                                            {langText.Body.MedianValue}
                                        </Radio>}
                                </Col>
                            </Col>
                        </InlineForm>
                    </AccordionItemPanel>
                </AccordionItem>
            </Accordion>
        );

        return itemArr;
    }

    render() {
        return (
            <BlockUi tag="div" blocking={this.props.compareFlag ? this.props.state.compare_menu_blocking : this.props.state.menu_blocking} message={this.props.langText.Body.Wait} keepInView>
                <Row className="menu-row">
                    <Col className="title-col col-style" xs={12} sm={12}>
                        {
                            !this.props.compareFlag &&
                            <div className="font-weight-bold">
                                {this.props.langText.Body.SummaryCondition}
                            </div>
                        }
                        {
                            this.props.compareFlag ?
                            <div className="margin-left-05 margin-top-517"></div>
                            :
                            <div className="margin-left-05 margin-top-05">
                                {this.getClearBtn()}
                                {this.getSummaryBtn()}
                            </div>
                        }
                        <div>
                            { 
                                this.props.state.view_level === "CallAnalysisSummaryCompare" &&
                                <Col xs={12} md={4} lg={4}> 
                                    <div className="font-weight-bold margin-bottom-07">
                                        {this.props.compareFlag ? 
                                            this.props.langText.Body.CompareB : this.props.langText.Body.CompareA}
                                    </div>
                                </Col>
                            }
                            {this.getCompanySelectInfo()}
                            {this.getDepartmentSelectInfo()}
                            {this.getTemplateSelectInfo()}
                            <hr className="menu-hr"/>
                        </div>
                    </Col>
                    <Col className="col-style padding-top-0" xs={12} sm={12}>
                        {this.getConditionInfo()}
                        {this.getDetailConditionInfo()}
                    </Col>
                </Row>
            </BlockUi>
        );
    }
}
